import axios from 'axios';
import uniqby from 'lodash.uniqby';
import {
  DATA_LOADED, QUERY_PARAM_LOADED, QUERY_PARAM_SORT, ZIPCODE,
} from './constants';
import { ALL_VEHICLES_FLAG_VALUE } from '../selectors/constants';
import { checkDefaultVehicle } from './vehicles';

export function dataLoaded(data) {
  return {
    type: DATA_LOADED,
    data,
  };
}

export function dataLoadedByZipcode(data) {
  return {
    type: ZIPCODE.DATA_LOADED,
    data,
  };
}

export function queryParamsLoaded(data) {
  return {
    type: QUERY_PARAM_LOADED,
    data,
  };
}

export function sortQueryParamLoaded(data) {
  return {
    type: QUERY_PARAM_SORT,
    data,
  };
}

/**
 * thunk (action that returns a function in redux) to load initial data
 */
export function loadData(url, callback) {
  return (dispatch) => axios.get(url)
    .then((result) => result.data)
    .then((json) => {
      // Extract vehicles from offers list
      // TODO: Delete the next line when ILX has totally deleted
      // Ignore all the offers related to ILX, temporary change of the ticket WTSJOAHM-328
      const validOffers = json.Offers.filter(entry => entry.ModelGroupName !== 'ILX' && entry.ModelGroupName !== 'RLX');
      window.offersData = JSON.parse(JSON.stringify(validOffers));
      const vehicles = uniqby(
        validOffers.map(
          (obj) => ({ model: obj.ModelGroupName }),
        ),
        (obj) => obj.model,
      )
        .filter((obj) => obj.model !== ALL_VEHICLES_FLAG_VALUE);
      dispatch(dataLoaded({
        offers: validOffers,
        vehicles,
      }));
      dispatch(checkDefaultVehicle());

      if (callback) {
        callback();
      }
    });
}

export function loadDataByZipcode(url) {
  return (dispatch) => axios.get(url)
    .then((result) => result.data)
    .then((json) => {
      dispatch(dataLoadedByZipcode(json));
    });
}
